module.exports = __webpack_public_path__ + "/images/logo-af-etsy.7fc4dac.svg";